import React from "react";
import styles from "../styles/privacy.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentWrapper}>
        <h1 className={styles.pageHeader}>Privacy Policy</h1>

        <div className={styles.section}>
          <h2>Introduction</h2>
          <p>
            This Privacy Policy explains how Job Assistant ("we", "us", or
            "our") collects and handles information. The Service primarily
            operates locally on your computer to ensure maximum privacy.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Information We Collect</h2>
          <ul>
            <li>
              <strong>Account Information:</strong> Your email address is
              collected during registration or purchase to manage your account
              and communicate with you.
            </li>
            <li>
              <strong>Payment Information:</strong> Payments are processed via
              third-party providers (e.g., Razorpay, Stripe). We do not store
              full card details.
            </li>
            <li>
              <strong>Usage Data (Optional & Anonymized):</strong> Aggregated,
              anonymized statistics (e.g., number of applications submitted) may
              be collected to improve Service performance.
            </li>
          </ul>
          <p>
            <strong>What We Don’t Collect:</strong> Your resume, LinkedIn
            credentials, and job application details remain local to your
            device. We never upload them to our servers.
          </p>
        </div>

        <div className={styles.section}>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>To provide and maintain the Service.</li>
            <li>To process payments and manage subscriptions.</li>
            <li>To send important updates or support messages.</li>
            <li>To analyze anonymized usage data and improve functionality.</li>
            <li>To prevent fraud and enforce Terms of Service.</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>Data Security & Local Processing</h2>
          <p>
            The Service processes resumes and job applications locally on your
            computer. We implement reasonable safeguards to protect collected
            information (like email) but no method of transmission or storage is
            100% secure.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Data Sharing</h2>
          <p>
            We do not sell or rent your personal data. Limited sharing may occur
            only:
          </p>
          <ul>
            <li>
              <strong>With Service Providers:</strong> For payment processing or
              essential emails.
            </li>
            <li>
              <strong>For Legal Reasons:</strong> If required by law or to
              protect our rights and users’ safety.
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>Cookies</h2>
          <p>
            Our website may use essential cookies for login sessions. The local
            app itself does not rely on cookies or trackers.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Your Data Rights</h2>
          <p>
            You can request access, updates, or deletion of your account by
            contacting us at the email below. Some data may be retained for
            legal or operational reasons.
          </p>
        </div>

        <div className={styles.section}>
          <h2>International Users</h2>
          <p>
            If you access the Service from outside India, note that your data
            may be processed in India.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Changes to Policy</h2>
          <p>
            We may update this Privacy Policy as needed. Continued use of the
            Service means you accept the updated policy.
          </p>
        </div>

        <div className={`${styles.section} ${styles.contactSection}`}>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, contact us at{" "}
            <a href="mailto:help.jobassistant@gmail.com">
              help.jobassistant@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
